import React from 'react';
import { Subscription } from '../types';
import { Button, Flex, Text, Card } from './base-components';
import { useTranslation } from '../i18n/TranslationContext';

interface Props {
  subscriptions: Subscription[];
  onUnsubscribe: (sub: Subscription) => void;
}

export const SubscriptionList: React.FC<Props> = ({
  subscriptions,
  onUnsubscribe,
}) => {
  const { t } = useTranslation();
  if (!subscriptions.length) {
    return <Text variant="muted" opacity={60}>{t('pages.notifications.noSubscriptions')}</Text>;
  }

  // Get display name from various possible fields
  const getName = (sub: any) => {
    return sub.name || sub.entity_name || 'Unknown';
  };

  // Get URL from various possible fields
  const getUrl = (sub: any) => {
    return sub.promoter_url || sub.venue_url || sub.artist_url || sub.url || null;
  };

  // Get type label
  const getTypeLabel = (type: string) => {
    return type.charAt(0).toUpperCase() + type.slice(1);
  };

  return (
    <Flex direction="col">
      {subscriptions.map((sub: any, index) => (
        <Card key={sub.id || `${sub.type}-${sub.entity_id}-${index}`} mb={4}>
          <Flex justify="between" align="center" gap={4}>
            <Flex direction="col" grow>
              <Text variant="title" mb={1}>
                {getName(sub)}
              </Text>
              <Flex gap={2} align="center">
                <span className="text-xs px-2 py-0.5 rounded bg-white/10 text-white/70">
                  {getTypeLabel(sub.type)}
                </span>
                {getUrl(sub) && (
                  <a
                    href={getUrl(sub)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs text-[#3b82f6] hover:text-[#60a5fa] transition-colors"
                  >
                    View on DICE
                  </a>
                )}
              </Flex>
            </Flex>
            <Button variant="secondary" onClick={() => onUnsubscribe(sub)}>
              {t('common.unsubscribe')}
            </Button>
          </Flex>
        </Card>
      ))}
    </Flex>
  );
};


